export default __webpack_public_path__ + "static/media/pdf.c6777b67.svg";